import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
   
    getAllLoans(sortBy, sortOrder, pageNumber, pageSize, isApprover) {
        return axios.get('/api/loan', { params : {
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageNumber: pageNumber,
            pageSize: pageSize,
            isApprover: isApprover
        }})
    },

    
}